import { MessageBox, Loading } from "element-ui";
import { reportG7 } from "./../services/reportG7.service";

const moment = require("moment");
const month_th = [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
const month_th_abbreviation =[ "ม.ค.-", "ก.พ.-", "มี.ค.-", "เม.ย.-", "พ.ค.-", "มิ.ย.-", "ก.ค.-", "ส.ค.-", "ก.ย.-", "ต.ค.-", "พ.ย.-", "ธ.ค.-"]
const state = {
  showChart: false, 
  showDataNotFound: false,
  datasets:[],
  options:{},
  prototype: {
    chart: {
      type: "spline"
    },
    title: {
      text: "",
      align: "center"
    },
    yAxis: {
      min: 0,
      max:100,
      title: {
        text: "ร้อยละ"
      },
      tickInterval:10
    },
    xAxis: {
      categories: [''],
      crosshair: true
    },
    tooltip: {
      valueSuffix: '%',
      shared:true,
      backgroundColor: '#FFFF',
      borderColor: 'black',
      borderWidth: 0.1,
      headerFormat: '<span style="font-size:14px">{point.x}</span><br/>',
      // pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>',
     
    },
    plotOptions: {
      spline: {
        dataLabels: {
            enabled: true
        },
        enableMouseTracking: true,
        animation: {
            duration: 2000
        }
      }
    },
    exporting: {
      buttons: {
        contextButton:{
          menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS","viewData"]
        }
      }
    },
    credits: {
        enabled: false
    },
    series: [
      
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom"
            }
          }
        }
      ]
    }
  },
  charts: [],
}
const actions = {
  async setChartData({ commit, state }, formdata) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let resultFix = await reportG7.getReportDataFixed(formdata);
    let result = await reportG7.getReportData(formdata);
    let propotion = await reportG7.getPropotion(formdata)
      if (result.status === 200 && resultFix.status === 200) {
        if(result.data.length == 0 && resultFix.data.length == 0){
          state.showDataNotFound = true
          state.showChart = false
          setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
          state.showChart = true
          state.showDataNotFound = false
          switch (formdata.type_report) {
            case "between_month":{
              let temp = moment(formdata.type_data.monthto).add(1, "M")._d;
              let obj = {
                date: {
                  start: formdata.type_data.monthfrom,
                  end: moment(temp).subtract(1, "seconds")._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydatafixed: resultFix.data,
                qrydataPropotion: propotion.data,
              };
              commit("BETWEEN_MONTH", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "year":{
              let temp = moment(formdata.type_data.year, "YYYY-MM-DD").add(1, "Y")._d;
              let obj = {
                forminfo: formdata,
                qrydata: result.data,
                qrydatafixed: resultFix.data,
                qrydataPropotion: propotion.data,
                date: {
                  start: moment(formdata.type_data.year, "YYYY-MM-DD")._d,
                  end: moment(temp).subtract(1, "seconds")._d
                }
              };
              commit("YEAR", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "between_year":{
              let temp = moment(formdata.type_data.yearto).add(1, "year")._d;
              let obj = {
                date: {
                  start: formdata.type_data.yearfrom,
                  end: moment(temp).subtract(1, "seconds")._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydatafixed: resultFix.data,
                qrydataPropotion: propotion.data,
              };
              commit("BETWEEN_YEAR", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "quarter":{
              let obj = {
                date: {
                  start: moment(formdata.type_data.quarter_year).add(
                    formdata.type_data.quarter * 3 - 3,
                    "Month"
                  )._d,
                  end: moment(formdata.type_data.quarter_year).add(
                    formdata.type_data.quarter * 3,
                    "Month"
                  )._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydatafixed: resultFix.data,
                qrydataPropotion: propotion.data,
              };
              commit("QUARTER", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "between_quarter":{
              let obj = {
                date: {
                  start: moment(formdata.type_data.quarter_year_from).add(
                    formdata.type_data.quarterfrom * 3 - 3,
                    "Month"
                  )._d,
                  end: moment(formdata.type_data.quarter_year).add(
                    formdata.type_data.quarterto * 3,
                    "Month"
                  )._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydatafixed: resultFix.data,
                qrydataPropotion: propotion.data,
              };
              commit("BETWEEN_QUARTER", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
          }
        }
      } else {
        setTimeout(function(){ loadingInstance.close() }, 250);
        MessageBox.confirm(result.message, "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        });
      }
      
  },
};

const mutations = {
  BETWEEN_MONTH(state, obj) {
    state.charts = []
    let propotion = obj.qrydataPropotion
    let datefrom = obj.forminfo.type_data.monthfrom;
    let monthfrom = parseInt(moment(new Date(datefrom)).format("MM"));
    let yearfrom = parseInt(moment(new Date(datefrom)).format("YYYY")) + 543;
    let dateto = obj.forminfo.type_data.monthto;
    let monthto = parseInt(moment(new Date(dateto)).format("MM"));
    let yearto = parseInt(moment(new Date(dateto)).format("YYYY")) + 543;
    let providerlist = obj.forminfo.list;
    let provider_id = obj.forminfo.type_providers == 'group' ? JSON.parse(providerlist[0].group_company_list) : [providerlist[0].id]
    let provider = ""
    let newChart = JSON.parse(JSON.stringify(state.prototype))
    obj.forminfo.type_providers == "group"?provider = providerlist[0].group_name_th:provider = providerlist[0].brand_name
    newChart.title.text = "ร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของผู้ให้บริการ "+provider+" ระหว่างเดือน"+month_th[monthfrom-1]+ " ปี พ.ศ. "+yearfrom+ " ถึงเดือน"+month_th[monthto-1]+" ปี พ.ศ. "+ yearto
    let categoriesData = []
    let dataMin = []
    let dataSec = []
    let dataRegulateSecond = []
    for(let date = obj.date.start; date < obj.date.end ; date = moment(date).add(1,'M')){
      let month = parseInt(moment(new Date(date)).format("MM"))
      let year = parseInt(moment(new Date(date)).add(543,"y").format("YY"))
      let check_year = parseInt(moment(new Date(date)).format("YYYY"))
      let curmonth = moment(date).format('YYYY-MM-DD')
      let amount = {
        minute:0,
        seconds:0
      }
      if(check_year < 2020){
        let rowdatafixed = obj.qrydatafixed.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth && provider_id.includes(item.provider_id))
        if(rowdatafixed.length != 0){
          for(let i = 0; i < rowdatafixed.length; i++){
            amount.minute += rowdatafixed[i].minute_amount
            amount.seconds += rowdatafixed[i].second_amount
          }
        }
        let percentMin = parseFloat(((amount.minute/(amount.minute+amount.seconds))*100).toFixed(2))
        let percentSec = parseFloat(((amount.seconds/(amount.minute+amount.seconds))*100).toFixed(2))
        categoriesData.push(month_th_abbreviation[month - 1] + year)
        !isNaN(percentMin) ? dataMin.push(parseFloat((percentMin).toFixed(2))) : dataMin.push(null)
        !isNaN(percentSec) ? dataSec.push(parseFloat((percentSec).toFixed(2))) : dataSec.push(null)
        !isNaN(percentMin) && !isNaN(percentSec) ? dataRegulateSecond.push(parseFloat((propotion[0].proportion_second).toFixed(2))) : dataRegulateSecond.push(null)
      } else {
        let rowdata = obj.qrydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth && provider_id.includes(item.provider_id))
        for(let i = 0; i < rowdata.length; i++){
          if(rowdata[i].service_charge_type.toLowerCase() == "minute"){
            amount.minute += rowdata[i].total
          }else if(rowdata[i].service_charge_type.toLowerCase() == 'second'){
            amount.seconds += rowdata[i].total
          }
        }
        let percentMin = parseFloat(((amount.minute/(amount.minute+amount.seconds))*100).toFixed(2))
        let percentSec = parseFloat(((amount.seconds/(amount.minute+amount.seconds))*100).toFixed(2))
        !isNaN(percentMin) ? dataMin.push(parseFloat((percentMin).toFixed(2))) : dataMin.push(null)
        !isNaN(percentSec) ? dataSec.push(parseFloat((percentSec).toFixed(2))) : dataSec.push(null)
        !isNaN(percentMin) && !isNaN(percentSec) ? dataRegulateSecond.push(parseFloat((propotion[0].proportion_second).toFixed(2))) : dataRegulateSecond.push(null)
        categoriesData.push(month_th_abbreviation[month - 1] + year)
      }
    }
    newChart.series.push({
      name: '% โปรนาที',
      data: dataMin,
      color: "rgb(255,0,0)"
    })
    newChart.series.push({
      name: '% โปรวินาที',
      data: dataSec,
      color: "rgb(0,0,255)",
      dashStyle: 'shortdot'
    })
    newChart.series.push({
      name: 'สัดส่วนโปรวินาที',
      data: dataRegulateSecond,
      color : "rgb(0, 204, 0)",
      dashStyle: 'longdash'
    })
    newChart.xAxis.categories = categoriesData
    //SET DATA LABEL
    newChart.plotOptions.spline.dataLabels.allowOverlap = true
    newChart.chart.events = {
      render: function() {
        var chart = this;
        chart.series.forEach(function(series) {
          series.points.forEach(function(point) {
            if (point.y < 50) {
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y+30);
            }else if(point.y > 50){
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y-15);
            }
          });
        });
      }
    }
    setTimeout(() => {
      state.charts.push(newChart)
    }, 75);
  },
  YEAR(state, obj) {
    state.charts = []
    let propotion = obj.qrydataPropotion
    let yearThai = moment(obj.forminfo.type_data.year).add(543, 'Y').year()
    let providerlist = obj.forminfo.list;
    let provider_id = obj.forminfo.type_providers == 'group' ? JSON.parse(providerlist[0].group_company_list) : [providerlist[0].id]
    let provider = ""
    obj.forminfo.type_providers == "group" ? provider = providerlist[0].group_name_th : provider = providerlist[0].brand_name
    let newChart = JSON.parse(JSON.stringify(state.prototype))
    newChart.title.text = "ร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของผู้ให้บริการ " + provider + " ปี พ.ศ. " + yearThai
    let categoriesData = []
    let dataMin = []
    let dataSec = []
    let dataRegulateSecond = []
    for(let date = obj.date.start; date < obj.date.end; date = moment(date).add(1,'M')){
      let month = parseInt(moment(new Date(date)).format("MM"))
      let year = parseInt(moment(new Date(date)).add(543,"y").format("YY"))
      let check_year = parseInt(moment(new Date(date)).format("YYYY"))
      categoriesData.push(month_th_abbreviation[month - 1] + year) 
      let curmonth = moment(date).format('YYYY-MM-DD')
      let amount = {
        minute: 0,
        seconds: 0
      }
      if(check_year < 2020){
        let rowdatafixed = obj.qrydatafixed.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth && provider_id.includes(item.provider_id))
        for(let i = 0; i < rowdatafixed.length; i++){
          if(rowdatafixed.length != 0){
            amount.minute += rowdatafixed[i].minute_amount
            amount.seconds += rowdatafixed[i].second_amount
          }
        }
        let percentMin = parseFloat(((amount.minute/(amount.minute+amount.seconds))*100).toFixed(2))
        let percentSec = parseFloat(((amount.seconds/(amount.minute+amount.seconds))*100).toFixed(2))
        !isNaN(percentMin) ? dataMin.push(parseFloat((percentMin).toFixed(2))) : dataMin.push(null)
        !isNaN(percentSec) ? dataSec.push(parseFloat((percentSec).toFixed(2))) : dataSec.push(null)
        !isNaN(percentMin) && !isNaN(percentSec) ? dataRegulateSecond.push(parseFloat((propotion[0].proportion_second).toFixed(2))) : dataRegulateSecond.push(null)
      } else if(check_year >= 2020){
        let rowdata = obj.qrydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth && provider_id.includes(item.provider_id))
        console.log(rowdata)
        for(let i = 0; i < rowdata.length; i++){
          if(rowdata[i].service_charge_type.toLowerCase() == "minute"){
            amount.minute += rowdata[i].total
          }else if(rowdata[i].service_charge_type.toLowerCase() == "second"){
            amount.seconds += rowdata[i].total
          }
        }
        let percentMin = parseFloat(((amount.minute/(amount.minute+amount.seconds))*100).toFixed(2))
        let percentSec = parseFloat(((amount.seconds/(amount.minute+amount.seconds))*100).toFixed(2))
        !isNaN(percentMin) ? dataMin.push(parseFloat((percentMin).toFixed(2))) : dataMin.push(null)
        !isNaN(percentSec) ? dataSec.push(parseFloat((percentSec).toFixed(2))) : dataSec.push(null)
        !isNaN(percentMin) && !isNaN(percentSec) ? dataRegulateSecond.push(parseFloat((propotion[0].proportion_second).toFixed(2))) : dataRegulateSecond.push(null)
      }
    }

    newChart.series.push({
      name: '% โปรนาที',
      data: dataMin,
      color: "rgb(255,0,0)"
    })
    newChart.series.push({
      name: '% โปรวินาที',
      data: dataSec,
      color: "rgb(0,0,255)",
      dashStyle: 'shortdot'
    })
    newChart.series.push({
      name: 'สัดส่วนโปรวินาที',
      data: dataRegulateSecond,
      color : "rgb(0, 204, 0)",
      dashStyle: 'longdash'
    })
    newChart.xAxis.categories = categoriesData
    //SET DATA LABEL
    newChart.plotOptions.spline.dataLabels.allowOverlap = true
    newChart.chart.events = {
      render: function() {
        var chart = this;
        chart.series.forEach(function(series) {
          series.points.forEach(function(point) {
            if (point.y < 50) {
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y+30);
            }else if(point.y > 50){
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y-15);
            }
          });
        });
      }
    }
    setTimeout(() => {
      state.charts.push(newChart)
    }, 75);
  },
  BETWEEN_YEAR(state, obj) {
    state.charts = []
    let propotion = obj.qrydataPropotion
    let datafixed = obj.qrydatafixed
    let data = obj.qrydata
    let datefrom = obj.forminfo.type_data.yearfrom;
    let dateto = obj.forminfo.type_data.yearto;
    let yearfrom = parseInt(moment(new Date(datefrom)).format("YYYY")) + 543;
    let yearto = parseInt(moment(new Date(dateto)).format("YYYY")) + 543;
    let providerlist = obj.forminfo.list;
    let provider_id = obj.forminfo.type_providers == 'group' ? JSON.parse(providerlist[0].group_company_list) : [providerlist[0].id]
    let provider = ""
    obj.forminfo.type_providers == "group"?provider = providerlist[0].group_name_th:provider = providerlist[0].brand_name
    let newChart = JSON.parse(JSON.stringify(state.prototype))
    newChart.title.text = "ร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของผู้ให้บริการ " + provider + " ระหว่างปี พ.ศ. " + yearfrom + " ถึงปี พ.ศ. " + yearto
    let categoriesData = []
    let dataChartMin = []
    let dataChartSec = []
    let dataRegulateSecond =[]
    for(let date = obj.date.start; date < obj.date.end; date = moment(date).add(1,'Y')){
      let checkyear = parseInt(moment(new Date(date)).format("YYYY"))
      if(checkyear < 2020){
          let yearThai= parseInt(moment(new Date(date)).add(543,"y").format("YYYY"))
          let dataMin = 0
          let dataSec = 0
          for(let dateM = obj.date.start;dateM < obj.date.end ; dateM = moment(dateM).add(1,'M')){
            let year = parseInt(moment(new Date(dateM)).format("YYYY"))
            let curmon = moment(dateM).format('YYYY-MM-DD')
            let amount = { 
              min:0,
              sec:0
            }
            if(checkyear == year){
              let rowdata = datafixed.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') === curmon && provider_id.includes(item.provider_id))
              for(let r = 0; r < rowdata.length; r++){
                amount.min += rowdata[r].minute_amount
                amount.sec += rowdata[r].second_amount
              }
              dataSec += (amount.sec)
              dataMin += (amount.min)
            }
          }
          let sum_min = dataMin
          let sum_sec = dataSec
          
          dataMin != 0 && dataSec != 0 ? dataRegulateSecond.push(propotion[0].proportion_second) : dataRegulateSecond.push(null)
          sum_min != 0 ? dataChartMin.push(parseFloat((sum_min/((sum_min+sum_sec))*100).toFixed(2))) : dataChartMin.push(null)
          sum_sec != 0 ? dataChartSec.push(parseFloat((sum_sec/((sum_min+sum_sec))*100).toFixed(2))) : dataChartSec.push(null)
          categoriesData.push("ปี " + yearThai)
         
      } else if(checkyear >= 2020){
        let yearThai = moment(new Date(date)).add(543,"y").year()
        let dataMin = 0
        let dataSec = 0
        if(data.length != 0){
          for(let dateM = obj.date.start; dateM < obj.date.end; dateM = moment(dateM).add(1,'M')){
            let year = parseInt(moment(new Date(dateM)).format("YYYY"))
            let curmonth = moment(dateM).format('YYYY-MM-DD')
            let amount = { 
              min: 0,
              sec: 0
            }
            if(year == checkyear){
              for(let pr = 0; pr < provider_id.length; pr++){
                let rowdata = data.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') === curmonth && provider_id.includes(item.provider_id))
                for(let r = 0; r < rowdata.length; r++){
                  if(rowdata[r].service_charge_type.toLowerCase() == "minute"){
                    amount.min += rowdata[r].total
                  }else if(rowdata[r].service_charge_type.toLowerCase() == "second"){
                    amount.sec += rowdata[r].total
                  }
                }
              }
              dataMin += (amount.min)
              dataSec += (amount.sec)
            }
          }
          let sum_min = dataMin
          let sum_sec = dataSec
          let resultMin = (sum_min/(sum_min+sum_sec))*100
          let resultSec = (sum_sec/(sum_min+sum_sec))*100
          if(resultMin&&resultSec){
            categoriesData.push("ปี "+yearThai)
            dataRegulateSecond.push(propotion[0].proportion_second)
            dataChartMin.push(parseFloat((resultMin).toFixed(2)))
            dataChartSec.push(parseFloat((resultSec).toFixed(2)))
          }
          else{
            categoriesData.push("ปี "+yearThai)
            dataChartMin.push(null)
            dataChartSec.push(null)
          }
        }
        else{
          categoriesData.push("ปี "+yearThai)
          dataChartMin.push(null)
          dataChartSec.push(null)
        }

      }
    }
    newChart.xAxis.categories = categoriesData
    newChart.series.push({
        name: '% โปรนาที',
        data: dataChartMin,
        color: "rgb(255,0,0)"
      })
    newChart.series.push({
      name: '% โปรวินาที',
      data: dataChartSec,
      color: "rgb(0,0,255)",
      dashStyle: 'shortdot'
    })
    newChart.series.push({
      name: 'สัดส่วนโปรวินาที',
      data: dataRegulateSecond,
      color : "rgb(0, 204, 0)",
      dashStyle: 'longdash'
    })
    //SET DATA LABEL
    newChart.plotOptions.spline.dataLabels.allowOverlap = true
    newChart.chart.events = {
      render: function() {
        var chart = this;
        chart.series.forEach(function(series) {
          series.points.forEach(function(point) {
            if (point.y < 50) {
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y+30);
            }else if(point.y > 50){
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y-15);
            }
          });
        });
      }
    }
    setTimeout(() => {
      state.charts.push(newChart)
    }, 75);
  },
  QUARTER(state, obj) {
    state.charts = []
    let data = obj.qrydata
    let datafixed = obj.qrydatafixed
    let propotion = obj.qrydataPropotion
    let quarter = obj.forminfo.type_data.quarter;
    let date = obj.forminfo.type_data.quarter_year;
    let year = parseInt(moment(new Date(date)).format("YYYY")) + 543;
    let providerlist = obj.forminfo.list;
    let provider_id = obj.forminfo.type_providers == 'group' ? JSON.parse(providerlist[0].group_company_list) : [providerlist[0].id]
    let provider = ""
    obj.forminfo.type_providers == "group"?provider = providerlist[0].group_name_th:provider = providerlist[0].brand_name
    let newChart = JSON.parse(JSON.stringify(state.prototype))
    newChart.title.text = "ร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของผู้ให้บริการ " + provider + " ในไตรมาสที่ " + quarter + " ปี พ.ศ. " + year
    let categoriesData = []
    let dataMin = []
    let dataSec = []
    let dataRegulateMinute =[]
    let dataRegulateSecond = []
    state.charts.series = []
    for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
      let curmonth = moment(date).format('YYYY-MM-DD')
      let month= parseInt(moment(new Date(date)).format("MM"))
      let year= parseInt(moment(new Date(date)).add(543,"y").format("YY"))
        let amount = {
          min:0,
          sec:0
        }
        let rowdatafixed = datafixed.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') === curmonth && provider_id.includes(item.provider_id))
        let rowdata = data.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') === curmonth && provider_id.includes(item.provider_id))
        if(moment(curmonth).year() < 2020){
          for(let r = 0; r < rowdatafixed.length; r++){
            amount.min += rowdatafixed[r].minute_amount
            amount.sec += rowdatafixed[r].second_amount
          }
        } else {
          for(let r = 0; r < rowdata.length; r++){
            if(rowdata[r].service_charge_type.toLowerCase() == "minute"){
              amount.min += rowdata[r].total
            }else if(rowdata[r].service_charge_type.toLowerCase() == "second"){
              amount.sec += rowdata[r].total
            }
          }
        }
        let percentMin = parseFloat(((amount.min/(amount.min+amount.sec))*100).toFixed(2))
        let percentSec = parseFloat(((amount.sec/(amount.min+amount.sec))*100).toFixed(2))
        !isNaN(percentMin) ? dataMin.push(parseFloat((percentMin).toFixed(2))) : dataMin.push(null)
        !isNaN(percentSec) ? dataSec.push(parseFloat((percentSec).toFixed(2))) : dataSec.push(null)
        dataRegulateMinute.push(propotion[0].proportion_minute)
        dataRegulateSecond.push(propotion[0].proportion_second)
        categoriesData.push(month_th_abbreviation[month-1]+year)
    }

    newChart.xAxis.categories = categoriesData
    newChart.series.push({
        name: '% โปรนาที',
        data: dataMin,
        color: "rgb(255,0,0)"
      })
      newChart.series.push({
      name: '% โปรวินาที',
      data: dataSec,
      color: "rgb(0,0,255)",
      dashStyle: 'shortdot'
      
    })
    newChart.series.push({
      name: 'สัดส่วนโปรวินาที',
      data: dataRegulateSecond,
      color : "rgb(0, 204, 0)",
      dashStyle: 'longdash'
    })
    //SET DATA LABEL
    newChart.plotOptions.spline.dataLabels.allowOverlap = true
    newChart.chart.events = {
      render: function() {
        var chart = this;
        chart.series.forEach(function(series) {
          series.points.forEach(function(point) {
            if (point.y < 50) {
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y+30);
            }else if(point.y > 50){
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y-15);
            }
          });
        });
      }
    }
    setTimeout(() => {
      state.charts.push(newChart)
    }, 75);
  },
  BETWEEN_QUARTER(state, obj) {
    state.charts = []
    let data = obj.qrydata
    let datafixed = obj.qrydatafixed
    let propotion = obj.qrydataPropotion
    let quarterfrom = obj.forminfo.type_data.quarterfrom;
    let quarterto = obj.forminfo.type_data.quarterto;
    let datefrom = obj.forminfo.type_data.quarter_year_from;
    let dateto = obj.forminfo.type_data.quarter_year;
    let yearfrom = parseInt(moment(new Date(datefrom)).format("YYYY")) + 543;
    let yearto = parseInt(moment(new Date(dateto)).format("YYYY")) + 543;
    let providerlist = obj.forminfo.list;
    let provider_id = obj.forminfo.type_providers == 'group' ? JSON.parse(providerlist[0].group_company_list) : [providerlist[0].id]
    let provider = ""
    obj.forminfo.type_providers == "group"?provider = providerlist[0].group_name_th:provider = providerlist[0].brand_name
    let newChart = JSON.parse(JSON.stringify(state.prototype))
    newChart.title.text = "ร้อยละของจำนวนรายการส่งเสริมการขายตามจริงเป็นวินาทีและนาทีของผู้ให้บริการ " + provider + " ในไตรมาสที่ " + quarterfrom + " ปี พ.ศ. "+yearfrom+ " ถึงไตรมาสที่ "+quarterto+ " ปี พ.ศ. "+yearto
    let categoriesData = []
    let dataMin =[]
    let dataSec =[]
    let dataRegulateSecond =[]
    for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(3,'M')){
      let checkyear = parseInt(moment(new Date(date)).format("YYYY"))
      let sum_min = 0
      let sum_sec = 0
      if(checkyear < 2020){
        for(let monthly = moment(date).format('YYYY-MM-DD'); monthly < moment(date).add(3, 'M').subtract(1, 'd').format('YYYY-MM-DD') ; monthly = moment(monthly).add(1,'M').format('YYYY-MM-DD')){
          let curmonth = moment(monthly).format('YYYY-MM-DD')
          let amount = {
            min:0,
            sec:0
          }
          let rowdatafixed = datafixed.filter(item => provider_id.includes(item.provider_id) && moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
          for(let r=0;r<rowdatafixed.length;r++){
            amount.min += rowdatafixed[r].minute_amount
            amount.sec += rowdatafixed[r].second_amount
          }
          sum_min += amount.min
          sum_sec += amount.sec
        }
      } else if(checkyear >= 2020){
        for(let monthly = moment(date).format('YYYY-MM-DD'); monthly <  moment(date).add(3, 'M').subtract(1, 'd').format('YYYY-MM-DD'); monthly = moment(monthly).add(1,'M').format('YYYY-MM-DD')){
          let curmonth = moment(monthly).format('YYYY-MM-DD')
          let amount = {
            min:0,
            sec:0
          }
          let rowdata = data.filter(item => provider_id.includes(item.provider_id) && moment(item.monthly_regulate).format('YYYY-MM-DD') ==curmonth)
          for(let r=0;r<rowdata.length;r++){
            if(rowdata[r].service_charge_type.toLowerCase() == "minute"){
              amount.min += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == "second"){
              amount.sec += rowdata[r].total
            }
          }
          sum_min += amount.min
          sum_sec += amount.sec
        }
      }
      let resultMin = parseFloat(((sum_min/(sum_min+sum_sec))*100).toFixed(2))
      let resultSec = parseFloat(((sum_sec/(sum_min+sum_sec))*100).toFixed(2))
      !isNaN(resultMin) ? dataMin.push(resultMin) : dataMin.push(null)
      !isNaN(resultSec) ? dataSec.push(resultSec) : dataSec.push(null)
      !isNaN(resultMin) && !isNaN(resultSec) ? dataRegulateSecond.push(propotion[0].proportion_second) : dataRegulateSecond.push(null)
      categoriesData.push(moment(date).quarter()+'Q'+moment(date).add(543, 'y').year())
    }
    newChart.xAxis.categories = categoriesData
    newChart.series.push({
        name: '% โปรนาที',
        data: dataMin,
        color: "rgb(255,0,0)"
    })
    newChart.series.push({
      name: '% โปรวินาที',
      data: dataSec,
      color: "rgb(0,0,255)",
      dashStyle: 'shortdot'
      
    })
    newChart.series.push({
      name: 'สัดส่วนโปรวินาที',
      data: dataRegulateSecond,
      color : "rgb(0, 204, 0)",
      dashStyle: 'longdash'
    })
    //SET DATA LABEL
    newChart.plotOptions.spline.dataLabels.allowOverlap = true
    newChart.chart.events = {
      render: function() {
        var chart = this;
        chart.series.forEach(function(series) {
          series.points.forEach(function(point) {
            if (point.y < 50) {
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y+30);
            }else if(point.y > 50){
              point.dataLabel.translate(point.dataLabel.x, point.dataLabel.y-15);
            }
          });
        });
      }
    }
    setTimeout(() => {
      state.charts.push(newChart)
    }, 75);
  }
};

export const Report_PP = {
  namespaced: true,
  state,
  actions,
  mutations
};
